import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useHistory, useParams } from 'react-router-dom';
import withContext from '../common/withContext';
import ProjectContext from './projectContext';
import DataConnector from './dataconnector';
import EndUser from './enduser';
import './credentials.scss';
import { SdfSegmentedControl } from '@synerg/react-components';
import { getActiveExpiredCertInfo } from '../certificate/certificateAlert';

function Credentials({ context, setSelectedTab, setEndUserApiTabActive }) {
	// eslint-disable-next-line no-unused-vars
	const { enduser } = useParams();
	const history = useHistory();
	const { projectDetail: { _id: projectId, b2bConsumerAppID, b2cConsumerAppID, platform, type } } = context;
	const [selectedSegment, setSelectedSegment] = useState(b2bConsumerAppID ? 0 : 1);
	const [allCertsInfo, setAllCertsInfo] = useState({ certificates: [], certsDetails: {}, loading: true });

	const onSegmentChange = (event) => {
		setSelectedSegment(event.detail);
	};

	const segments = [{ label: `Data connector`, value: 0, disabled: b2bConsumerAppID ? false : true }, { label: `End-user/SSO`, value: 1, disabled: b2cConsumerAppID ? false : true }];

	const fetchCertificationInformation = async () => {
		try {
			const result = await axios.get(`${import.meta.env.VITE_ROOT_PATH}/api/partner/certificates`);
			if (result.data.certificates) {
				const certsDetails = getActiveExpiredCertInfo(result.data.certificates);
				setAllCertsInfo({ certificates: result.data.certificates, certsDetails: certsDetails, loading: false });
			}
		} catch (e) {
			setAllCertsInfo({ certificates: e, loading: false });
		}
	};

	useEffect(() => {
		fetchCertificationInformation();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);


	useEffect(() => {
		if (selectedSegment === 0) {
			history.push(`/projects/${projectId}/credentials`);
		}
		else {
			history.push(`/projects/${projectId}/credentials/enduser`);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedSegment]);


	return (<div>
		<div className="text-heading-07 font-black mt-8">{type === 'DEV' ? "Development Credentials" : "Production credentials"}</div>
		{platform !== 'datacloud' && <div className="flex justify-center mt-10">
			<SdfSegmentedControl
				items={segments}
				onSdfChange={(event) => onSegmentChange(event)}
				selectedIndex={selectedSegment}
			/>
		</div>}
		{selectedSegment === 0 && <DataConnector setSelectedTab={setSelectedTab} setEndUserApiTabActive={setEndUserApiTabActive} allCertsInfo={allCertsInfo} />}
		{selectedSegment === 1 && <EndUser setSelectedTab={setSelectedTab} setEndUserApiTabActive={setEndUserApiTabActive} allCertsInfo={allCertsInfo} />}
	</div>);
}

export default withContext(Credentials, ProjectContext);
